import { CanDeactivateFn } from '@angular/router';

export interface CoachingSessionLeaveHost { canLeaveCoachingSession(): boolean }
export const coachingSessionLeaveGuard: CanDeactivateFn<CoachingSessionLeaveHost> = host => host.canLeaveCoachingSession();
